import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { TransactionsPage } from './pages/TransactionsPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { SettingsPage } from './pages/SettingsPage';
import { AuthPage } from './pages/AuthPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { LandingPage } from './pages/LandingPage';
import { WaitlistLandingPage } from './pages/WaitlistLandingPage';
import { WaitlistAdminPage } from './pages/WaitlistAdminPage';
import { AboutPage } from './pages/AboutPage';
import { Layout } from './components/Layout';
import { useAuth } from './hooks/useAuth';
import { PropertyDetailPage } from './pages/PropertyDetailPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ContactPage } from './pages/ContactPage';
import { BudgetPage } from './pages/BudgetPage';
import { GoalsPage } from './pages/GoalsPage';
import { CalendarPage } from './pages/CalendarPage';
import { DividendPage } from './pages/DividendPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { APIDocsPage } from './pages/APIDocsPage';
import { HelpCenterPage } from './pages/HelpCenterPage';
import { StatusPage } from './pages/StatusPage';
import { CommunityPage } from './pages/CommunityPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { GDPRPage } from './pages/GDPRPage';
import { CareersPage } from './pages/CareersPage';

function App() {
  const { loading } = useAuth();

  // Development mode - bypass authentication to see the full UI
  const isDevelopment = process.env.NODE_ENV === 'development';
  const bypassAuth = true; // Set to true to bypass authentication for testing

  if (loading && !bypassAuth) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<WaitlistLandingPage />} />
        <Route path="/real-landing" element={<LandingPage />} />
        <Route path="/waitlist-admin" element={<WaitlistAdminPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/login" element={<AuthPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/api" element={<APIDocsPage />} />
        <Route path="/help-center" element={<HelpCenterPage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/gdpr" element={<GDPRPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/app" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="budget" element={<BudgetPage />} />
          <Route path="goals" element={<GoalsPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="dividends" element={<DividendPage />} />
          <Route path="properties" element={<PropertiesPage />} />
          <Route path="properties/:id" element={<PropertyDetailPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App; 